import { render, staticRenderFns } from "./ExportParentView.vue?vue&type=template&id=4ba3284e&"
import script from "./ExportParentView.vue?vue&type=script&lang=js&"
export * from "./ExportParentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports